module.exports = __webpack_public_path__ + "static/media/GESSTwoLight-Light.c9e577cb.woff2";